import React, { Component } from 'react';
import SlideShow from 'react-image-show';
import {isValidArr} from '../utils';


const getSlides = (slides) => {
  if(!slides)return null;
  const {folder, fileNames, ext} = slides;

  if(!isValidArr(fileNames))return null;

  const fileList = [];
  fileNames.forEach((fname) => {
    try{
      const img = require(`../images/${folder}/${fname}${ext}`);
      fileList.push(img);
    }
    catch(e){
      alert(e.message)
    }
  });

  return fileList;
}
class SlideShowPage extends Component {
  
  render() {
    return (      
      <div style={{...this.props.style}}>
        <SlideShow
          images={getSlides(this.props)}
          width='1000px'//"920px"
          imagesWidth='900px'//"800px"
          imagesHeight='600px'//"450px"
          imagesHeightMobile="156vw"
          thumbnailsWidth="920px"
          thumbnailsHeight="12vw"
          thumbnails='false'
          indicators 
          infinite 
          arrows
          //fixedImagesHeight
        /> 
      </div>
    );
  }
}

export default SlideShowPage



// WEBPACK FOOTER //
// ./src/components/SlideShowPage.js